module.exports = __webpack_public_path__ + "img/berechnung.db2e2db4.jpg";